import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';
import { createPortal } from 'react-dom';

type ConfirmationModalProps = {
  onAccept: any;
  onCancel: any;
  onClose: any;
  description: string,
  confirmButtonText: string,
  cancelButtonText: string
}

export function ConfirmationModal(props: ConfirmationModalProps) {
  function onAccept() {
    props.onAccept();
  };

  function onCancel() {
    props.onCancel();
  };

  function onClickOutside(event) {
    if (event.target !== event.currentTarget) {
      return;
    }

    props.onClose();
  };

  // eslint-disable-next-line camelcase
  const { description, confirmButtonText, cancelButtonText } = props;

  return (
    <div className="cart-dialog__overlay" onClick={onClickOutside}>
      <div className="cart-dialog__dialog">

        <button type="button" className="button-less cart-dialog__close" onClick={onCancel}>
          <PesIcon class="cart-dialog__close-figure" size={pesIconSizes.SMALL}>
            action_delete_cross
          </PesIcon>
        </button>

        <p className="cart-dialog__message">
          <span className="cart-dialog__text">{description}</span>
        </p>

        <div className="cart-dialog__controls">
          <button type="button" className="cart-dialog__btn cart-dialog__btn-secondary" onClick={onCancel}>
            {cancelButtonText}
          </button>
          <button type="button" className="cart-dialog__btn cart-dialog__btn-primary btn-primary" onClick={onAccept}>
            {confirmButtonText}
          </button>
        </div>

      </div>
    </div>
  );
}

export default (props: ConfirmationModalProps) => createPortal(
  <ConfirmationModal {...props}/>,
  document.body,
);
